import {
  emailRegex,
  nameRegex,
  tenDigitMobileRegex,
} from "DataMapper/Common/RegexConstants"
import { fetchCityApi } from "../utils"

export const ieltsEliteFormRequiredFields = [
  "ieltsExamType",
  "whatCareerStage",
  "whenIelts",
  "name",
  "emailId",
  "phone",
  "leadSource",
  "signinPurpose",
  "formId",
  "onboardingPurpose",
  "city",
]

export const detEliteFormRequiredFields = [
  "name",
  "emailId",
  "phone",
  "leadSource",
  "signinPurpose",
  "formId",
  "onboardingPurpose",
  "city",
]
export const ieltsEliteJson: any = {
  form_id: "Ielts Demo Form",
  form_meta: {
    title: "",
    image: "",
  },
  no_of_steps: 7,
  page_distribution: [4, 3],
  is_auto_progressive: true,
  required: ieltsEliteFormRequiredFields,
  fields: [
    {
      question_id: 1,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "ieltsExamType",
      question_text: "What's your IELTS Type?",
      options: [
        {
          label: "General",
          value: "GENERAL",
        },
        {
          label: "Academic",
          value: "ACADEMIC",
        },
        {
          label: "Not Sure",
          value: "OTHER",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 2,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whatCareerStage",
      question_text: "What are you currently doing?",
      options: [
        {
          label: "Student",
          value: "STUDENT",
        },
        {
          label: "Working",
          value: "WORKING",
        },
        {
          label: "Recently graduated",
          value: "RECENTLY_GRADUATED",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 3,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whenIelts",
      question_text: "When are you giving IELTS?",
      options: [
        {
          label: "Within 3 months",
          value: "WITHIN_3_MONTHS",
        },
        {
          label: "Within 3-6 months",
          value: "WITHIN_3_6_MONTHS",
        },
        {
          label: "Already Booked",
          value: "BOOKED_EXAM",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 7,
      label: "Search your City",
      type: "searchInput",
      fieldValue: "city",
      question_text: "Select your Current City",
      default_visibility: true,
      fetchSuggestions: (query: string) => {
        return fetchCityApi(query)
      },
      defaultSuggestions: [
        "Bengaluru, Karnataka",
        "Chennai, Tamil Nadu",
        "Hyderabad, Telangana",
        "Mumbai, Maharashtra",
        "Pune, Maharashtra",
        "Delhi, Delhi",
        "Kolkata, West Bengal",
        "Gurugram, Haryana",
      ],
    },
    {
      question_id: 4,
      label: "Name*",
      type: "textInput",
      fieldValue: "name",
      question_text: "Enter your details to book IELTS MasterClass",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: nameRegex,
        errorMessage: "Enter correct name",
      },
    },
    {
      question_id: 5,
      label: "Email Address*",
      type: "textInput",
      fieldValue: "emailId",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: emailRegex,
        errorMessage: "Please enter correct email",
      },
    },
    {
      question_id: 6,
      label: "Phone Number*",
      type: "textInput",
      fieldValue: "phone",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: tenDigitMobileRegex,
        errorMessage: "please enter correct number",
      },
    },
  ],
}

export const ieltsDemoMasterclassJson: any = {
  form_id: "Ielts Demo Form",
  form_meta: {
    title: {},
    image: "",
  },
  no_of_steps: 7,
  page_distribution: [4, 3],
  is_auto_progressive: true,
  required: ieltsEliteFormRequiredFields,
  fields: [
    {
      question_id: 1,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "ieltsExamType",
      question_text: "What's your IELTS Type?",
      options: [
        {
          label: "General",
          value: "GENERAL",
        },
        {
          label: "Academic",
          value: "ACADEMIC",
        },
        {
          label: "Not Sure",
          value: "OTHER",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 2,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whatCareerStage",
      question_text: "What are you currently doing?",
      options: [
        {
          label: "Student",
          value: "STUDENT",
        },
        {
          label: "Working",
          value: "WORKING",
        },
        {
          label: "Recently graduated",
          value: "RECENTLY_GRADUATED",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 3,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whenIelts",
      question_text: "When are you giving IELTS?",
      options: [
        {
          label: "Within 3 months",
          value: "WITHIN_3_MONTHS",
        },
        {
          label: "Within 3-6 months",
          value: "WITHIN_3_6_MONTHS",
        },
        {
          label: "Already Booked",
          value: "BOOKED_EXAM",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 7,
      label: "Search your City",
      type: "searchInput",
      fieldValue: "city",
      question_text: "Select your Current City",
      default_visibility: true,
      fetchSuggestions: (query: string) => {
        return fetchCityApi(query)
      },
      defaultSuggestions: [
        "Bengaluru, Karnataka",
        "Chennai, Tamil Nadu",
        "Hyderabad, Telangana",
        "Mumbai, Maharashtra",
        "Pune, Maharashtra",
        "Delhi, Delhi",
        "Kolkata, West Bengal",
        "Gurugram, Haryana",
      ],
    },
    {
      question_id: 4,
      label: "Name*",
      type: "textInput",
      fieldValue: "name",
      question_text: "Enter your details to book IELTS MasterClass",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: nameRegex,
        errorMessage: "Enter correct name",
      },
    },
    {
      question_id: 5,
      label: "Email Address*",
      type: "textInput",
      fieldValue: "emailId",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: emailRegex,
        errorMessage: "Please enter correct email",
      },
    },
    {
      question_id: 6,
      label: "Phone Number*",
      type: "textInput",
      fieldValue: "phone",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: tenDigitMobileRegex,
        errorMessage: "please enter correct number",
      },
    },
  ],
}

export const ieltsDemoMasterclassJson2: any = {
  form_id: "Ielts Demo Form",
  form_meta: {
    title: (
      <div className="flex flex-col items-center md:mb-[-20px] px-6 md:px-0">
        <h2 className="font-bold md:text-[20px] text-[#0A0926] mb-4">
          🎉 Almost done
        </h2>
        <p className="text-[14px] md:text-[16px] text-[#686868] mb-4 md:mb-6 text-center">
          Just a few more details to give you a personalised session
        </p>
        <p className="bg-[#DDDDDD] h-[1px] w-full" />
      </div>
    ),
    image: "",
  },
  no_of_steps: 6,
  page_distribution: [3, 3],
  is_auto_progressive: true,
  required: ieltsEliteFormRequiredFields,
  fields: [
    {
      question_id: 1,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "ieltsExamType",
      question_text: "What's your IELTS Type?",
      options: [
        {
          label: "General",
          value: "GENERAL",
        },
        {
          label: "Academic",
          value: "ACADEMIC",
        },
        {
          label: "Not Sure",
          value: "OTHER",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 2,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whatCareerStage",
      question_text: "What are you currently doing?",
      options: [
        {
          label: "Student",
          value: "STUDENT",
        },
        {
          label: "Working",
          value: "WORKING",
        },
        {
          label: "Recently graduated",
          value: "RECENTLY_GRADUATED",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 3,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whenIelts",
      question_text: "When are you giving IELTS?",
      options: [
        {
          label: "Within 3 months",
          value: "WITHIN_3_MONTHS",
        },
        {
          label: "Within 3-6 months",
          value: "WITHIN_3_6_MONTHS",
        },
        {
          label: "Already Booked",
          value: "BOOKED_EXAM",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 4,
      label: "Name*",
      type: "textInput",
      fieldValue: "name",
      question_text: "Enter your details to book IELTS MasterClass",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: nameRegex,
        errorMessage: "Enter correct name",
      },
    },
    {
      question_id: 5,
      label: "Email Address*",
      type: "textInput",
      fieldValue: "emailId",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: emailRegex,
        errorMessage: "Please enter correct email",
      },
    },
    {
      question_id: 6,
      label: "Phone Number*",
      type: "textInput",
      fieldValue: "phone",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: tenDigitMobileRegex,
        errorMessage: "please enter correct number",
      },
    },
  ],
}

export const selfPrepJson: any = {
  form_id: "Self Prep Form",
  form_meta: {
    title: "",
    image: "",
  },
  no_of_steps: 6,
  page_distribution: [3, 3],
  is_auto_progressive: true,
  required: ieltsEliteFormRequiredFields,
  fields: [
    {
      question_id: 1,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "ieltsExamType",
      question_text: "What's your IELTS Type?",
      options: [
        {
          label: "General",
          value: "GENERAL",
        },
        {
          label: "Academic",
          value: "ACADEMIC",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
      numGridColumns: 2,
    },
    {
      question_id: 2,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whatCareerStage",
      question_text: "What are you currently doing?",
      options: [
        {
          label: "Student",
          value: "STUDENT",
        },
        {
          label: "Working",
          value: "WORKING",
        },
        {
          label: "Recently graduated",
          value: "RECENTLY_GRADUATED",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 3,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whenIelts",
      question_text: "When are you giving IELTS?",
      options: [
        {
          label: "Within 3 months",
          value: "WITHIN_3_MONTHS",
        },
        {
          label: "Within 3-6 months",
          value: "WITHIN_3_6_MONTHS",
        },
        {
          label: "Already Booked",
          value: "BOOKED_EXAM",
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 4,
      label: "Name*",
      type: "textInput",
      fieldValue: "name",
      question_text: "Enter your details to enroll for Self Prep",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: nameRegex,
        errorMessage: "Enter correct name",
      },
    },
    {
      question_id: 5,
      label: "Email Address*",
      type: "textInput",
      fieldValue: "emailId",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: emailRegex,
        errorMessage: "Please enter correct email",
      },
    },
    {
      question_id: 6,
      label: "Phone Number*",
      type: "textInput",
      fieldValue: "phone",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: tenDigitMobileRegex,
        errorMessage: "please enter correct number",
      },
    },
  ],
}
